const closeButtons = document.querySelectorAll('.close-modal');
const resetPasswordModal = document.querySelector('.reset-password__modal');

closeButtons.forEach((b) => {
    b.addEventListener('click', () => {
        resetPasswordModal.style.display = 'none';
        window.location.href = b.dataset.redirect;
    });
});
